import {ReactElement, MouseEvent} from 'react'
import {Trans} from 'react-i18next'
import {Link} from 'react-router-dom'
import {Divider, Grid, Typography} from '@material-ui/core'
import {Account} from '../../../../../graphql/types'
import messages from '../../../../../assets/messages'
import Amount from '../../../../Common/Amount'
import {useStyles} from './styles'

type BrokereePerformanceFeeCardFooterProps = {
  account: Account
}

export function BrokereePerformanceFeeCardFooter(props: BrokereePerformanceFeeCardFooterProps): ReactElement {
  const {account}  = props
  const {balance, currency} = account

  const classes = useStyles()

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()
    e.nativeEvent.stopPropagation()
  }

  return (
    <Grid item container direction='column' className={classes.container}>
      <Grid item className={classes.divider}>
        <Divider />
      </Grid>
      <Grid item className={classes.content} onClick={handleClick}>
        <Typography variant="inherit"><Trans {...messages.performanceFeeAccount} /></Typography>
        <Typography variant="inherit"><Amount value={balance} currency={currency} locale='en-US' /></Typography>
        <Link to={`/accounts/${account.id}`} className={classes.link}>
          <Trans {...messages.view} />
        </Link>
      </Grid>
    </Grid>
  )
}
